import { z } from 'zod';
import { PartnerNewsSchema } from '../../entities/partner-news/partner-news.schema';
/**
 * List Partner News
 * GET /api/v2/partner/news
 *
 * Published news only, pinned first, then newest first.
 */ export const ListPartnerNewsResponseSchema = z.object({
    data: z.array(PartnerNewsSchema)
});

//# sourceMappingURL=list-partner-news.schema.js.map